import { BillingPeriod } from '~/types';

export const getMonthlyPrice = (
  billingPeriod: BillingPeriod,
  recipientCount: number,
  monthlyPrice: number,
  yearlyMonthlyPrice: number
) => {
  return billingPeriod === 'monthly' ? recipientCount * monthlyPrice : recipientCount * yearlyMonthlyPrice;
};
